import {GameFrameView} from '@gongxigames/framework/slot/modules/gameFrame/GameFrameView';
import {GameFrameModuleName} from '@gongxigames/framework/slot/modules/gameFrame/GameFrameConstants';
import {Module} from '@gongxigames/framework/slot';

export class GameFrameFullScreenModule extends Module<GameFrameView> {
    public static readonly NAME: symbol = GameFrameModuleName;

    protected setupStates(): void {}

    protected setupViews(): void {
        this.setView(GameFrameView.NAME);
        this.view.hide();
    }
}
